import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import API from "../lib/api";
import { Section, ArticleCard, Pillar } from "../components/Common";
import PractitionerRecommendations from "../components/PractitionerRecommendations";
import DeepContentBlocks from "../components/DeepContentBlocks";
import { STATIC_HUB_DEEP_CONTENT } from "../config/staticHubDeepContent";
import { Heart, Activity, Apple, Brain, Sun, Sparkles } from "lucide-react";

export default function WomensWellnessPage() {
  const { t } = useTranslation();
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    API.get("/content/articles?category=womens-wellness&limit=12").then(({ data }) => setArticles(data.items || []));
  }, []);
  const pillars = t("womens.pillars", { returnObjects: true });
  const icons = [Sun, Heart, Activity, Sparkles, Brain, Apple];
  const deep = STATIC_HUB_DEEP_CONTENT.womens;
  return (
    <div data-testid="page-womens">
      <section className="relative overflow-hidden hero-bg">
        <div className="app-container pt-16 pb-12 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="text-xs tracking-[0.32em] uppercase gold-text" data-testid="womens-eyebrow">{t("womens.eyebrow")}</div>
            <h1 className="font-display text-4xl md:text-6xl mt-3 leading-[1.05] max-w-[14ch]" data-testid="womens-title">{t("womens.title")}</h1>
            <p className="text-white/75 mt-5 max-w-[52ch] leading-relaxed body-copy">{t("womens.subtitle")}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/dosha" className="btn-primary text-sm" data-testid="womens-cta-dosha">{t("womens.cta_dosha")}</Link>
              <Link to="/ask-donny" className="btn-secondary text-sm" data-testid="womens-cta-donny">{t("womens.cta_donny")}</Link>
            </div>
          </div>
          <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-white/10 max-w-md md:ml-auto">
            <img src="https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=crop&w=900&q=85" alt={t("womens.image_alt")} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
      <Section eyebrow={t("womens.pillars_eyebrow")} title={t("womens.pillars_title")}>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="womens-pillars">
          {pillars.map((p, i) => <Pillar key={i} label={p} icon={icons[i % icons.length]} />)}
        </div>
      </Section>
      <Section eyebrow={t("womens.editorial_eyebrow")} title={t("womens.editorial_title")} subtitle={t("womens.editorial_subtitle")}>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="womens-articles">
          {articles.map((a) => <ArticleCard key={a.id} article={a} />)}
        </div>
      </Section>
      <DeepContentBlocks
        pageTitle={deep.pageTitle}
        editorial={deep.editorial}
        quotes={deep.quotes}
        products={deep.products}
        askDonnyPrompt={deep.askDonnyPrompt}
        testidPrefix="womens-deep"
      />
      <PractitionerRecommendations
        eyebrow={t("marketplace.find_pro_eyebrow")}
        title={t("womens.practitioners_title")}
        subtitle={t("womens.practitioners_subtitle")}
        topic="womens-wellness"
        limit={3}
        testid="womens-practitioner-recs"
      />
    </div>
  );
}
